import { Box, Button, Container } from '@mui/material'
import { env } from "../../../core/Env";
import { rqx } from "../../../core/request/API";
import { useState } from 'react';
import moment from 'moment/moment';

export const Migration = () => {
    const table = ['tbl_order', 'tbl_order_details', 'tbl_delivery_details', 'tbl_payment', 'tbl_order_delivery_riders', 'tbl_booking_details']
    // const [date, setDate] = useState({start: '', end: ''})
    const [order, setOrder] = useState([])
    const [orderDetails, setOrderDetails] = useState([])
    const [deliveryDetails, setDeliveryDetails] = useState([])
    const [payment, setPayment] = useState([])
    const [deliveryRiders, setDeliveryRiders] = useState([])
    const [bookingDetails, setBoookingDetails] = useState([])
    const [loader, setLoader] = useState(false)
    const handlerRead = async(val) => {
        setLoader(true)
        if (val === 'tbl_order') {
            const r = await rqx.get(`<<tool>>/${env()}/transfer/order`)
            setOrder(r)
        }else if (val === 'tbl_order_details') {
            const r = await rqx.get(`<<tool>>/${env()}/transfer/orderDetails`)
            setOrderDetails(r)
        }else if (val === 'tbl_delivery_details') {
            const r = await rqx.get(`<<tool>>/${env()}/transfer/deliveryDetails`)
            setDeliveryDetails(r)
        }else if (val === 'tbl_payment') {
            const r = await rqx.get(`<<tool>>/${env()}/transfer/payment`)
            setPayment(r)
        }else if (val === 'tbl_order_delivery_riders') {
            const r = await rqx.get(`<<tool>>/${env()}/transfer/deliveryRiders`)
            setDeliveryRiders(r)
        }else if (val === 'tbl_booking_details') {
            const r = await rqx.get(`<<tool>>/${env()}/transfer/bookingDetails`)
            setBoookingDetails(r)
        }
        setLoader(false)
    }
    
    const handlerTransfer = async(val) => {
        setLoader(true)
        if (val === 'tbl_order') {
            if (order.length > 0) {
               for(let i = 0; i < order.length; i++){
                    const body = {
                        id: order[i].id,
                        series_num: order[i].series_number,
                        type: order[i].type,
                        promo_id: order[i].promo_id,
                        active: order[i].active,
                        data_status: order[i].data_status,
                        created_by: order[i].created_by,
                        created_at: order[i].created_at,
                        updated_by: order[i].updated_by,
                        updated_at: order[i].updated_at,
                        deleted_by: order[i].deleted_by,
                        deleted_at: order[i].deleted_at,
                    }
                    const res = await rqx.post(`<<tool>>/${env()}/transfer/createOrder`, body)
                    console.log(res)
               }
            }
        }else if (val === 'tbl_order_details') {
            if (orderDetails.length > 0) {
                for(let i = 0; i < orderDetails.length; i++){
                    const body = {
                        // tbl_order_product
                        id: orderDetails[i].id,
                        order_id: orderDetails[i].order_id,
                        promo_id: orderDetails[i].promo_id,
                        contact_number: orderDetails[i].contact_number,
                        last_name: orderDetails[i].last_name,
                        first_name: orderDetails[i].first_name,
                        email: orderDetails[i].email,
                        status: orderDetails[i].status,
                        quantity: orderDetails[i].quantity,
                        delivery_option: orderDetails[i].delivery_option,
                        remarks: orderDetails[i].remarks,
                        total_amount: orderDetails[i].total_amount,
                        // tbl_user_delivery_info
                        street_building: orderDetails[i].street_building,
                        delivery_date: orderDetails[i].delivery_date,
                        delivery_time: orderDetails[i].delivery_time,
                        created_by: orderDetails[i].created_by,
                        created_at: orderDetails[i].created_at,
                        updated_by: orderDetails[i].updated_by,
                        updated_at: orderDetails[i].updated_at,
                        deleted_by: orderDetails[i].deleted_by,
                        deleted_at: orderDetails[i].deleted_at,
                        data_status: orderDetails[i].data_status,
                        active: orderDetails[i].active,
                        // tbl_order na yung remarks
                        // tbl_order_product_details
                        // order_product_id = id from tbl_order_product
                        // user_delivery_info_id = id from tbl_user_delivery_info
                        // delivery_pickup_info_id = id from tbl_delivery_pickup_info in hrc_mira
                    }
                    const res = await rqx.post(`<<tool>>/${env()}/transfer/createOrderDetails`, body)
                    console.log(res)
                }
            }
        }else if (val === 'tbl_delivery_details') {
            if (deliveryDetails.length > 0) {
                for(let i = 0; i < deliveryDetails.length; i++){
                    const body = {
                        id: deliveryDetails[i].id,
                        order_id: deliveryDetails[i].order_id,
                        order_details_id: deliveryDetails[i].order_details_id,
                        shipping_fee_id: deliveryDetails[i].shipping_fee_id,
                        first_name: deliveryDetails[i].first_name,
                        last_name: deliveryDetails[i].last_name,
                        email: deliveryDetails[i].email,
                        contact_number: deliveryDetails[i].contact_number,
                        street_building: deliveryDetails[i].street_building,
                        city_id: deliveryDetails[i].city_id,
                        barangay_id: deliveryDetails[i].barangay_id,
                        delivery_option: deliveryDetails[i].delivery_option,
                        delivery_date: deliveryDetails[i].delivery_date,
                        delivery_time: deliveryDetails[i].delivery_time,
                        created_by: deliveryDetails[i].created_by,
                        created_at: deliveryDetails[i].created_at,
                        updated_by: deliveryDetails[i].updated_by,
                        updated_at: deliveryDetails[i].updated_at,
                        deleted_by: deliveryDetails[i].deleted_by,
                        deleted_at: deliveryDetails[i].deleted_at,
                        data_status: deliveryDetails[i].data_status,
                        active: deliveryDetails[i].active,
                    }
                    const res = await rqx.post(`<<tool>>/${env()}/transfer/createDeliveryDetails`, body)
                    console.log(res)
                }
            }
        }else if (val === 'tbl_payment') {
            if(payment.length > 0){
                for(let i = 0; i < payment.length; i++){
                    const body = {
                        order_id: payment[i].order_id,
                        reference_number: payment[i].reference_number,
                        status: payment[i].status,
                        active: payment[i].active,
                        data_status: payment[i].data_status,
                        created_by: payment[i].created_by,
                        created_at: payment[i].created_at,
                        updated_by: payment[i].updated_by,
                        updated_at: payment[i].updated_at,
                        deleted_by: payment[i].deleted_by,
                        deleted_at: payment[i].deleted_at,
                    }
                    const res = await rqx.post(`<<tool>>/${env()}/transfer/createPayment`, body)
                    console.log(res)
                }
            }
        }else if(val === 'tbl_order_delivery_riders'){
            if(deliveryRiders.length > 0){
                for(let i = 0; i < deliveryRiders.length; i++){
                    const body = {
                        id: deliveryRiders[i].id,
                        promo_id: deliveryRiders[i].promo_id,
                        order_id: deliveryRiders[i].order_id,
                        name: deliveryRiders[i].name,
                        contact_number: deliveryRiders[i].contact_number,
                        remarks: deliveryRiders[i].remarks,
                        active: deliveryRiders[i].active,
                        data_status: deliveryRiders[i].data_status,
                        created_by: deliveryRiders[i].created_by,
                        created_at: deliveryRiders[i].created_at,
                        updated_by: deliveryRiders[i].updated_by,
                        updated_at: deliveryRiders[i].updated_at,
                        deleted_by: deliveryRiders[i].deleted_by,
                        deleted_at: deliveryRiders[i].deleted_at,
                    }
                    const res = await rqx.post(`<<tool>>/${env()}/transfer/createDeliveryRiders`, body)
                    console.log(res)
                }

            }
        }else if (val === 'tbl_booking_details') {
            if(bookingDetails.length > 0){
                for(let i = 0; i < bookingDetails.length; i++){
                    const body = {
                        id: bookingDetails[i].id,
                        promo_id: bookingDetails[i].promo_id,
                        order_id: bookingDetails[i].order_id,
                        contact_number: bookingDetails[i].contact_number,
                        last_name: bookingDetails[i].last_name,
                        first_name: bookingDetails[i].first_name,
                        email: bookingDetails[i].email,
                        check_in_date: moment(bookingDetails[i].booking_start).format('MM-DD-YYYY'),
                        check_in_time: JSON.parse(bookingDetails[i].booking)[0].check_in,
                        check_out_date: moment(bookingDetails[i].booking_end).format('MM-DD-YYYY'),
                        check_out_time: JSON.parse(bookingDetails[i].booking)[0].check_out,
                        quantity: bookingDetails[i].quantity,
                        total_amount: bookingDetails[i].total_amount,
                        status: bookingDetails[i].status,
                        active: bookingDetails[i].active,
                        data_status: bookingDetails[i].data_status,
                        created_by: bookingDetails[i].created_by,
                        created_at: bookingDetails[i].created_at,
                        updated_by: bookingDetails[i].updated_by,
                        updated_at: bookingDetails[i].updated_at,
                        deleted_by: bookingDetails[i].deleted_by,
                        deleted_at: bookingDetails[i].deleted_at,
                    }
                    const res = await rqx.post(`<<tool>>/${env()}/transfer/createBookingDetails`, body)
                    console.log(res)
                }
            }
        }
        setLoader(false)
    }
    console.log(deliveryDetails)
    return (
        <Container maxWidth="xl">
            <Box fontSize={24} component="b" >Migration of Data</Box>
            <Box display="flex" flexDirection="column" gap="24px" mt={5}>
                {/* <Box display="flex" alignItems="center" gap="16px">
                     <Box component="b">Date Start</Box>
                     <TextField type='date' size='small' name="start" onChange={(e) => handlerChange(e)} />
                    <Box component="b">Date End</Box>
                    <TextField type='date' size='small' name="end" onChange={(e) => handlerChange(e)} 
                        InputProps={{
                            inputProps: {
                                min: date.start
                            }
                        }}    
                    />
                </Box> */}
                {
                    table.map((v,k) => (
                        <Box display="flex" alignItems="center" gap="16px" key={k}>
                            <Box>{v}</Box>
                            <Box component={Button} variant="outlined" width={100} onClick={() => handlerRead(v)} disabled={loader}>Read</Box>
                            <Box component={Button} variant="contained" width={100} onClick={() => handlerTransfer(v)} disabled={loader}>Transfer</Box>
                        </Box>
                    ))
                }
            </Box>
        </Container>
    )
}
